// StoryPopup.jsx
// Story/clue popup shown before each activity — matches room.php's
// #customStageModal / .modal-text populated from `stageTexts`. Text is
// static per Phase 2 scope; sequencing (which clue, when) is wired in later phases.
import React from 'react';
import GamePopup from './GamePopup';
import './TextPopup.css';

function StoryPopup({ open, onClose, text, testId = 'escape-story-popup' }) {
  return (
    <GamePopup open={open} onClose={onClose} size="small" ariaLabel="Clue" testId={testId}>
      <div className="escape-popup-text">{text}</div>
    </GamePopup>
  );
}

export default StoryPopup;
